<template>
  <v-layout>
    <app-loader
      title="Загрузка данных Запроса"
      :loading="!pageLoaded"
    />

    <v-layout
      v-show="pageLoaded"
      wrap
    >
      <v-flex xs5>
        <!-- INFO -->
        <v-card
          class="my-0 mr-1 ml-0 pa-2"
          :style="{
            height: blockHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
          }"
        >
          <v-layout align-center>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                small
                icon
                class="ma-0"
                @click="$router.go(-1)"
              >
                <v-icon color="grey darken-1">
                  arrow_back
                </v-icon>
              </v-btn>
              <span>Назад</span>
            </v-tooltip>
            <h2 class="px-2 subheading font-weight-bold">
              {{ title }}
            </h2>
            <v-spacer />

            <v-menu
              :disabled="currentVersion !== 0"
              menu-props="offsetY"
            >
              <v-btn
                slot="activator"
                small
                color="primary"
                dark
                :loading="changeStateProccessedByServer"
              >
                {{ currentState.title }}
                <v-icon
                  right
                  small
                >
                  keyboard_arrow_down
                </v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="state in availableStates"
                  :key="state.id"
                  :disabled="disabled"
                  @click="changeState(state)"
                >
                  <v-list-tile-title>{{ state.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

            <app-states-history
              :id="id"
              :disabled="disabled"
            />

            <VersionSwitcher
              v-model="currentVersion"
              :items="versions"
              :disabled="disabled"
            />

            <v-tooltip bottom>
              <template
                v-if="!allowVisible"
                slot="activator"
              >
                <app-same-region-requests :id="id" />
              </template>
              <span>Запросы из того же региона</span>
            </v-tooltip>

            <RelationsMap
              v-if="!allowVisible"
              :id="id"
              resource="shipment-requests"
            />
          </v-layout>
          <v-layout
            class="ma-1 pa-2"
            :style="{
              height: blockInfoHeight + 'px',
              'overflow-y': 'auto',
              'overflow-x': 'hidden'
            }"
          >
            <v-flex xs12>
              <app-info :items="infoItems">
                <template slot="goods-summary">
                  <GoodsSummary :id="shippingId ? shippingId : null" />
                </template>
              </app-info>
            </v-flex>
          </v-layout>

          <v-layout justify-center>
            <v-tooltip top>
              <v-btn
                slot="activator"
                small
                icon
              >
                <v-icon>print</v-icon>
              </v-btn>
              <span>Печать</span>
            </v-tooltip>

            <DownloadXlsxBtn
              :loading="loadingExcel"
              @download="downloadOutputForm()"
            />

            <v-tooltip top>
              <v-btn
                v-if="!isUserClient"
                slot="activator"
                :disabled="!canEdit"
                small
                icon
                @click="showEditor"
              >
                <v-icon>edit</v-icon>
              </v-btn>

              <v-dialog
                v-if="editor"
                v-model="editorDialog"
                persistent
                width="1000"
                style="overflow-y: hidden"
              >
                <v-card>
                  <v-card-text class="pa-0">
                    <app-editor
                      :id="id"
                      @cancel="closeEditor"
                      @save="handleShipmentRequestChange"
                      @saveWithNotification="
                        handleShipmentRequestChangeWithNotification
                      "
                    />
                  </v-card-text>
                </v-card>
              </v-dialog>
              <span>Редактировать</span>
            </v-tooltip>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs3>
        <!-- PROPOSALS -->
        <v-card
          :style="{
            height: blockProposals + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
          }"
          class="mt-0 mx-1 mb-2 pa-2"
        >
          <app-proposals
            :id="id"
            :disabled="isUserClient || !canEdit"
            :items="proposals"
            @add="handleProposalAdd"
            @update="handleProposalAdd"
          />
        </v-card>

        <!-- PROCESSED VARIANTS -->
        <v-card
          v-if="!isUserClient"
          :style="{
            height: halfHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
          }"
          class="mt-1 mb-0 mx-1 pa-2"
        >
          <app-processed-variants
            :id="id"
            :items="processedVariants"
            :disabled="!canEdit"
            @add="getProcessedVariants"
            @update="getProcessedVariants"
            @delete="getProcessedVariants"
          />
        </v-card>
      </v-flex>

      <v-flex xs4>
        <v-card
          :style="{
            height: blockHeight + 'px',
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
          }"
          class="my-0 ml-1 mr-0 pa-2"
        >
          <v-tabs>
            <v-tab style="text-transform:none">
              <h2 class="subheading font-weight-bold">
                Сообщения
              </h2>
            </v-tab>
            <v-tab
              v-if="!isUserClient"
              style="text-transform:none"
            >
              <h2 class="subheading font-weight-bold">
                Заметки
              </h2>
            </v-tab>
            <v-tab style="text-transform:none">
              <h2 class="subheading font-weight-bold">
                Документы
                <span
                  v-if="attachments.length > 0"
                  class="blue--text text--darken-4"
                >({{ attachments.length }})</span>
              </h2>
            </v-tab>
            <!-- MESSAGES -->
            <v-tab-item>
              <app-messages
                :id="id"
                :items="messages"
                :disabled="!canEdit"
                @add="getMessages"
              />
            </v-tab-item>
            <!-- NOTES -->
            <v-tab-item v-if="!isUserClient">
              <app-notes
                :id="id"
                :items="notes"
                :disabled="!canAddNotes"
                @add="getNotes"
              />
            </v-tab-item>
            <!-- ATTACHMENTS -->
            <v-tab-item>
              <Attachments
                v-model="attachments"
                :resource="`shipment-requests/${id}`"
                :disabled="!canEdit"
                :allow-remove="allowVisible"
              />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import Info from "../../components/Info.vue";
import VersionSwitcher from "../../components/VersionSwitcher.vue";
import Editor from "./components/Editor.vue";
import Proposals from "./components/Proposals.vue";
import Notes from "./components/Notes.vue";
import Messages from "./components/Messages.vue";
import ProcessedVariants from "./components/ProcessedVariants.vue";
import StatesHistory from "./components/StatesHistory.vue";
import SameRegionRequests from "./components/SameRegionRequests.vue";
import RelationsMap from "../../components/RelationsMap.vue";
import Attachments from "../../components/attachments/Attachments.vue";
import userAccess from "./user-access.js";
import auth from "../../auth.js";
import GoodsSummary from "../shippings/components/info/GoodsSummary.vue";
import * as shipmentRequestsApi from "../../backend/shipmentRequestsApi.js";

export default {
  components: {
    appInfo: Info,
    VersionSwitcher,
    appEditor: Editor,
    appProposals: Proposals,
    appNotes: Notes,
    appMessages: Messages,
    appProcessedVariants: ProcessedVariants,
    appStatesHistory: StatesHistory,
    appSameRegionRequests: SameRegionRequests,
    RelationsMap,
    Attachments,
    GoodsSummary,
  },
  mixins: [userAccess],
  props: ["id"],
  data() {
    return {
      currentVersion: 0,
      editorDialog: false,
      editor: false,
      infoItems: [],
      tmpInfoItems: null,
      versions: [],
      proposals: [],
      createdDate: null,
      notes: [],
      attachments: [],
      processedVariants: [],
      messages: [],
      states: [
        { id: 0, title: "Новый" },
        { id: 1, title: "В обработку" },
        { id: 2, title: "Отменен" },
        { id: 3, title: "В поставки" },
        { id: 4, title: "Ожидать ответ клиента" },
        { id: 5, title: "Отказ клиента" },
      ],
      state: 0,
      changeStateProccessedByServer: false,
      infoLoaded: false,
      proposalsLoaded: true,
      messagesLoaded: true,
      notesLoaded: true,
      variantsLoaded: true,
      isUserClient: false,
      shippingId: null,
      loadingExcel: false,
    };
  },
  computed: {
    pageLoaded() {
      return (
        this.infoLoaded &&
        this.proposalsLoaded &&
        this.messagesLoaded &&
        this.notesLoaded &&
        this.variantsLoaded
      );
    },
    title() {
      return "Запрос № " + this.id;
    },
    canEdit() {
      return this.currentVersion === 0 && this.state !== 3 && this.state !== 5;
    },
    canAddNotes() {
      return this.canEdit || this.state === 5;
    },
    availableStates() {
      const availableForNew = [1, 2, 3];
      const availableForInProcess = [4, 3, 2];
      const availableForWaitForClientResponse = [1, 2, 3, 5];
      const availableForCanceledByClient = [1];
      const availableForCanceled = [1];

      return this.states.filter(state => {
        switch (this.state) {
          case 0:
            return availableForNew.indexOf(state.id) !== -1;
          case 1:
            return availableForInProcess.indexOf(state.id) !== -1;
          case 2:
            return availableForCanceled.indexOf(state.id) !== -1;
          case 4:
            return availableForWaitForClientResponse.indexOf(state.id) !== -1;
          case 5:
            return availableForCanceledByClient.indexOf(state.id) !== -1;
          default:
            return false;
        }
      });
    },
    currentState() {
      const state = this.states.find(state => state.id === this.state);
      switch (this.state) {
        case 1:
          return { id: state.id, title: "В обработке" };
        case 3:
          return { id: state.id, title: "В поставках" };
        case 4:
          return { id: state.id, title: "Ожидаем ответ клиента" };
        default:
          return state;
      }
    },
    isClient() {
      return localStorage.currentUserRole === "2";
    },
    blockHeight() {
      return window.innerHeight - 41;
    },
    blockInfoHeight() {
      return this.blockHeight - 108;
    },
    blockProposals() {
      return this.isUserClient ? this.blockHeight : this.halfHeight;
    },
  },
  watch: {
    currentVersion(newVersion, prevVersion) {
      if (prevVersion === 0) {
        this.tmpInfoItems = this.infoItems;
      }
      if (this.currentVersion) {
        this.getVersion(newVersion);
      } else {
        this.infoItems = this.tmpInfoItems;
        this.tmpInfoItems = null;
      }
    },
  },
  created() {
    this.getData();
    this.halfHeight = (window.innerHeight - 49) / 2;
    this.isUserClient = auth.getUser().isClient;
  },
  methods: {
    async getData() {
      this.infoLoaded = false;
      const res = await shipmentRequestsApi.getShipmentRequest(this.id);
      this.createdDate = this.$options.filters.date(res.data.Date);
      this.state = res.data.State.Id;

      this.getShipmentRequestInfo(res.data);

      if (res.data.Attachments) {
        this.attachments = res.data.Attachments.map(a => {
          return {
            id: a.Id,
            title: a.Title,
          };
        });
      }
      if (res.data.Versions) {
        this.versions = res.data.Versions.map(v => {
          return {
            id: v.Id,
            title:
              v.Id === 0
                ? v.Title
                : `${v.Title} от ${this.$options.filters.dateTime(
                  v.CreatedAt,
                )} (${v.Author})`,
            date: v.CreatedAt,
            author: v.Author,
          };
        });
        if (res.data.Notes) {
          this.notes = res.data.Notes.map(n => {
            return {
              id: n.Id,
              text: n.Text,
              date: n.CreatedAt,
              author: n.Author,
            };
          });
        }
        if (res.data.Proposals) {
          this.proposals = res.data.Proposals.map(p => {
            return {
              id: p.Id,
              title: p.Title,
              version: p.Version ? p.Version.Title : "Тек. версия",
              date: p.CreatedAt,
              author: p.Author
                ? {
                  id: p.Author.Id,
                  title: p.Author.Title,
                }
                : null,
              text: p.Text,
            };
          });
        }
        if (res.data.Messages) {
          this.messages = res.data.Messages.map(m => {
            return {
              id: m.Id,
              text: m.Text,
              date: m.CreatedAt,
              author: m.Author
                ? {
                  id: m.Author.Id,
                  title: m.Author.Title,
                }
                : null,
            };
          });
        }
        if (res.data.ProcessedVariants) {
          this.processedVariants = res.data.ProcessedVariants.map(a => {
            return {
              id: a.Id,
              title: a.Title,
              content: a.Content,
            };
          });
        }
        this.versions.unshift({
          id: 0,
          title: `Версия ${this.versions.length + 1} (актуальная)`,
        });
      }

      this.infoLoaded = true;
    },
    getShipmentRequestInfo(shipmentRequest) {
      this.shippingId = shipmentRequest.ShippingId;
      this.infoItems = [
        {
          title: "",
          items: [
            {
              title: "Дата создания",
              value: this.$options.filters.dateTime(shipmentRequest.Date),
              showAlways: true,
            },
            {
              title: "Автор",
              value: !shipmentRequest.Author
                ? ""
                : shipmentRequest.Author.Title
                  ? shipmentRequest.Author.Title
                  : shipmentRequest.Author.Username,
              showAlways: true,
            },
            {
              title: "Клиент",
              value: shipmentRequest.Client.Title,
              showAlways: true,
            },
            {
              title: "Менеджер",
              value: shipmentRequest.Employee.Title,
              showAlways: true,
            },
          ],
        },
        {
          title: "Первоначальное местонахождение груза",
          items: [
            {
              title: "Страна отправления",
              value: shipmentRequest.SendingCountry.Title,
              showAlways: true,
            },
            {
              title: "Квадрат",
              value: shipmentRequest.LoadingAddress.Postcode,
              showAlways: true,
            },
            {
              title: "Продавец",
              value: shipmentRequest.Factory.Title,
              showAlways: true,
            },
            {
              title: "Производитель",
              value: shipmentRequest.Manufacturer.Title,
              showAlways: true,
            },
            {
              title: "Клиент по документам",
              value: shipmentRequest.ClientAlias,
              showAlways: true,
            },
            {
              title: "Адрес погрузки",
              value: shipmentRequest.LoadingAddress.Title,
              showAlways: true,
            },
          ],
        },
        {
          title: "Информация о товаре",
          items: [
            {
              title: "Описание",
              value: shipmentRequest.GeneralProductDescription,
              showAlways: true,
            },
            {
              title: "Категория",
              value: shipmentRequest.ProductCategory
                ? shipmentRequest.ProductCategory.Title
                : "",
              showAlways: true,
            },
            {
              title: "Материал",
              value: shipmentRequest.ProductMaterial,
              showAlways: true,
            },
            {
              title: "Сфера применения",
              value: shipmentRequest.UsingSphere,
              showAlways: true,
            },
            {
              title: "Сайт товара",
              value: shipmentRequest.ProductSite,
              showAlways: true,
            },
            {
              title: "Стоимость партии груза",
              value: `${shipmentRequest.InvoiceSum} ${shipmentRequest.Currency.Title}`,
              showAlways: true,
            },
            {
              title: "Валюта",
              value: shipmentRequest.Currency.Title,
              showAlways: true,
            },
          ],
        },
        {
          title: "Адрес доставки товара",
          event: "goods-summary",
          items: [
            {
              title: "Тип поставки",
              value: shipmentRequest.ShippingType.Title,
              showAlways: true,
            },
            {
              title: "Страна получателя по док-ам фабрики/отправителя",
              value: shipmentRequest.DestinationCountry.Title,
              showAlways: true,
            },
            {
              title: "Страна",
              value: shipmentRequest.UnloadingCountry.Title,
              showAlways: true,
            },
            {
              title: "Город",
              value: shipmentRequest.UnloadingCity.Title,
              showAlways: true,
            },
            {
              title: "Адрес",
              value: shipmentRequest.UnloadingAddress.Title,
              showAlways: true,
            },
          ],
        },
        {
          title: "Характеристики товара",
          items: [
            {
              title: "Объем, м3",
              value: shipmentRequest.Volume,
              showAlways: true,
            },
            {
              title: "Вес брутто, кг",
              value: shipmentRequest.Brutto,
              showAlways: true,
            },
          ],
        },
        {
          title: "Метки в запросе",
          items: [
            {
              title: "Срочность",
              value: shipmentRequest.Urgency.Title,
              showAlways: false,
            },
            {
              title: "Способ упаковки",
              value: shipmentRequest.PackingMethod ? "Паллеты" : "Не паллеты",
              showAlways: false,
            },
            {
              title: "Негабарит",
              value: shipmentRequest.Oversized ? "Да" : "Нет",
              showAlways: false,
            },
            {
              title: "Груз оплачен",
              value: shipmentRequest.IsPayed ? "Да" : "Нет",
              showAlways: false,
            },
            {
              title: "Нужна ли EX",
              value: shipmentRequest.NeedEx.Title,
              showAlways: false,
            },
          ],
        },
      ];
    },
    async downloadOutputForm() {
      this.loadingExcel = true;
      const response = await shipmentRequestsApi.downloadOutputForm(this.id);
      this.downloadAsExel(this.id, response.data);
      this.loadingExcel = false;
    },
    downloadAsExel(id, fileData) {
      const blob = new Blob([fileData], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Запрос № ${id}.xlsx`;
      link.click();
    },
    showEditor() {
      this.editor = true;
      setTimeout(() => {
        this.editorDialog = true;
      }, 10);
    },
    closeEditor() {
      this.editorDialog = false;
      setTimeout(() => {
        this.editor = false;
      }, 200);
    },
    handleShipmentRequestChange() {
      this.closeEditor();
      this.getData();
    },
    async handleShipmentRequestChangeWithNotification() {
      const notificationChange =
        this.moment().format("DD.MM.YY HH:mm") +
        " Внесены изменения в запрос. Версия №" +
        (this.versions.length + 1);
      await shipmentRequestsApi.handleShipmentChangeWithNotification(
        this.id,
        notificationChange,
      );
      this.handleShipmentRequestChange();
    },
    async getProposals() {
      this.proposalsLoaded = false;
      this.proposals = await shipmentRequestsApi.getProposalsRequests(this.id);
      this.proposalsLoaded = true;
    },
    async getNotes() {
      this.notesLoaded = false;
      this.notes = await shipmentRequestsApi.getRequestNotes(this.id);
      this.notesLoaded = true;
    },
    async getProcessedVariants() {
      this.variantsLoaded = false;
      this.processedVariants = await shipmentRequestsApi.getProcessedVariants(
        this.id,
      );
      this.variantsLoaded = true;
    },
    async getMessages() {
      this.messagesLoaded = false;
      this.messages = await shipmentRequestsApi.getRequestMessages(this.id);
      this.messagesLoaded = true;
    },
    async changeState(newState) {
      this.changeStateProccessedByServer = true;
      await shipmentRequestsApi.changeRequestState(this.id, newState.id);
      this.state = newState.id;
      this.getMessages();
      this.changeStateProccessedByServer = false;
    },
    handleProposalAdd() {
      this.getProposals();
      this.getMessages();
    },
    async getVersion(newVersion) {
      const res = await shipmentRequestsApi.getCurrentVersion(
        this.id,
        newVersion,
      );
      this.getShipmentRequestInfo(res);
    },
  },
};
</script>

<style>
.compact > .v-list__tile {
  height: auto;
  font-size: 14px;
}

.v-list--two-line > .compact > .v-list__tile {
  height: auto;
  font-size: 14px;
}
</style>
